import { forwardRef } from "react";

import {
  TABLE_ROW_DEFAULTS,
  TABLE_ROW_DIVIDER_CLASS_NAME,
  TABLE_ROW_INDENT_CLASS_NAME,
  type TTRProps,
} from "@/ui/components/data-display/Table/Table.config";
import { cn } from "@/ui/lib/utils";

export const TR = forwardRef<HTMLTableRowElement, TTRProps>(
  (
    {
      className,
      divider = TABLE_ROW_DEFAULTS.divider,
      indent = TABLE_ROW_DEFAULTS.indent,
      ...props
    },
    ref,
  ) => (
    <tr
      {...props}
      ref={ref}
      data-component="TR"
      className={cn(
        divider && TABLE_ROW_DIVIDER_CLASS_NAME,
        indent && TABLE_ROW_INDENT_CLASS_NAME,
        className,
      )}
    />
  ),
);

TR.displayName = "TR";
